<div class="image-viewer-container" #container>
  <!-- Canvas Area -->
  <div class="canvas-container">
    <canvas 
      #canvas
      [style.cursor]="getCursorStyle()"
      (mousedown)="onMouseDown($event)"
      (mousemove)="onMouseMove($event)"
      (mouseup)="onMouseUp($event)"
      (mouseleave)="onMouseLeave($event)"
      (wheel)="onWheel($event)"
      (contextmenu)="onContextMenu($event)">
    </canvas>
    
    <!-- Instructions Overlay (when no image) -->
    <div class="instructions-overlay" *ngIf="!image">
      <mat-icon>image_search</mat-icon>
      <p>Select an image from the navigation pane</p>
      <ul class="hints">
        <li><strong>Mark mode:</strong> Select vertical/horizontal first, then click to mark lines</li>
        <li><strong>Cut:</strong> Mark lines then click Cut button</li>
        <li><strong>Scroll:</strong> Zoom in/out</li>
        <li><strong>Right-click drag:</strong> Pan image</li>
        <li><strong>Crop mode:</strong> Draw rectangle to crop</li>
      </ul>
    </div>
  </div>
</div>
